import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GenericApiService } from '@core/generic-api/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NDIStatus } from '../models/ndi.model';
import { DocumentModel } from '../models/document.model';

@Injectable({ providedIn: 'root' })
export class ParticipantApiService {
  static CONTRACT_DETAIL = 'contracts-participants/contract';
  static CONTRACT_PREVIEW = 'contracts-participants/preview/pdf';
  static CONTRACT_PREVIEW_HTML = 'contracts-participants/preview/html';
  static CONTRACT_ACTION = 'contracts-participant/action';
  static CONTRACT_ACTION_AUDIT = 'contracts-participant/action/manual-audit';
  static CONTRACT_ACTION_VERIFICATION = 'contracts-participant/action/send-verification';
  static CONTRACT_ACTION_VERIFY = 'contracts-participant/action/verify';
  static CONTRACT_PARTICIPANTS_INIT_NDI = 'contracts-participants/init-ndi-signing-session';
  static CONTRACT_PARTICIPANTS_NDI_CHECKING = 'contracts-participants/validate-ndi-signing-result';
  static CONTRACT_ACTION_TEMPORARY_SUBMISSION = 'contracts-participant/action/temporary-submission';
  static CONTRACT_UPLOAD_LINK = 'contracts-participants/upload-link/:type';
  static CONTRACT_ATTACH_FILE = 'contracts-participants/attachment';
  static CONTRACT_FEEDBACK = 'contracts-participants/feedback';

  private readonly apiService = inject(GenericApiService);

  loadHeader(accessToken: string) {
    return new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });
  }

  getContractDetail(accessToken: string) {
    // return this.httpClient
    //   .get(this.createAPIURL(ParticipantApiService.CONTRACT_DETAIL), {
    //     headers: this.loadHeader(accessToken),
    //   })
    //   .pipe(map((res: any) => DocumentModel.fromJson(res['data']) as DocumentModel));

    return this.apiService
      .get(
        ParticipantApiService.CONTRACT_DETAIL,
        {},
        {
          requestOptions: {
            headers: this.loadHeader(accessToken),
          },
        },
      )
      .pipe(
        map((res: any) => {
          console.log(res);
          console.log(DocumentModel.fromJson(res));
          return DocumentModel.fromJson(res);
          // return res;
        }),
      );
  }

  getUploadLink(accessToken: string, data: { type: any; name: any; acl?: any }) {
    const requestOptions = {
      params: {
        name: data.name,
        acl: data.acl,
      },
      headers: this.loadHeader(accessToken),
    };

    return this.apiService.get(ParticipantApiService.CONTRACT_UPLOAD_LINK, {}, { requestOptions });
    // .pipe(map((res: any) => res['data'] as NDIModel));

    // return this.httpClient
    //   .get(this.createAPIURL(ParticipantApiService.CONTRACT_UPLOAD_LINK, data), requestOptions)
    //   .pipe(map((res: any) => res['data']));
  }

  attachFile(accessToken: string, data: any): Observable<any> {
    return this.apiService.post(ParticipantApiService.CONTRACT_ATTACH_FILE, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_ATTACH_FILE), data, {
    //   headers: this.loadHeader(accessToken),
    // });
  }

  getContractPDF(accessToken: string) {
    return this.apiService.get(
      ParticipantApiService.CONTRACT_PREVIEW,
      {},
      {
        pretreatmentResponse: false,
        requestOptions: {
          headers: this.loadHeader(accessToken),
          responseType: 'arraybuffer',
        },
      },
    );
    // return this.httpClient
    //   .get(this.createAPIURL(ParticipantApiService.CONTRACT_PREVIEW), {
    //     headers: this.loadHeader(accessToken),
    //     responseType: 'arraybuffer',
    //   })
    //   .pipe(
    //     map(res => {
    //       // return res;
    //       // const blob = new Blob([res], {type: 'application/pdf'});
    //       // saveAs(blob, 'asdsad.pdf');
    //       return res;
    //     }),
    //   );
  }

  getContractHtml(accessToken: string): Observable<string> {
    return this.apiService.get(
      ParticipantApiService.CONTRACT_PREVIEW_HTML,
      {},
      {
        pretreatmentResponse: false,
        requestOptions: {
          headers: this.loadHeader(accessToken),
          responseType: 'text',
        },
      },
    );
    // return this.httpClient.get(this.createAPIURL(ParticipantApiService.CONTRACT_PREVIEW_HTML), {
    //   headers: this.loadHeader(accessToken),
    //   responseType: 'text',
    // });
  }

  postParticipantAction(data: any, accessToken: string) {
    return this.apiService.post(ParticipantApiService.CONTRACT_ACTION, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });

    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_ACTION), data, {
    //   headers: this.loadHeader(accessToken),
    // });
  }

  postManualEdit(data: { name: string; description: string; metadata?: object }, accessToken: string) {
    return this.apiService.post(ParticipantApiService.CONTRACT_ACTION_AUDIT, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_ACTION_AUDIT), data, {
    //   headers: this.loadHeader(accessToken),
    // });
  }

  sendVerification(accessToken: string) {
    return this.apiService.post(
      ParticipantApiService.CONTRACT_ACTION_VERIFICATION,
      {},
      {
        requestOptions: {
          headers: this.loadHeader(accessToken),
        },
      },
    );
    // return this.httpClient.post(
    //   this.createAPIURL(ParticipantApiService.CONTRACT_ACTION_VERIFICATION),
    //   {},
    //   {
    //     headers: this.loadHeader(accessToken),
    //   },
    // );
  }

  verify(data: { phone: any; code: any }, accessToken: string) {
    return this.apiService.post(ParticipantApiService.CONTRACT_ACTION_VERIFY, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_ACTION_VERIFY), data, {
    //   headers: this.loadHeader(accessToken),
    // });
  }

  postInitNDISession(accessToken: string, data: any) {
    return this.apiService.post(ParticipantApiService.CONTRACT_PARTICIPANTS_INIT_NDI, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // .pipe(map((res: any) => NDIModel.fromJson(res) as NDIModel));
    // return this.httpClient
    //   .post(this.createAPIURL(ParticipantApiService.CONTRACT_PARTICIPANTS_INIT_NDI), data, {
    //     headers: this.loadHeader(accessToken),
    //   })
    //   .pipe(map((res: any) => NDIModel.fromJson(res['data']) as NDIModel));
  }

  checkingNDISession(accessToken: string) {
    return (
      this.apiService
        .get(
          ParticipantApiService.CONTRACT_PARTICIPANTS_NDI_CHECKING,
          {},
          {
            requestOptions: {
              headers: this.loadHeader(accessToken),
            },
          },
        )
        // .pipe(map((res: any) => NDIStatus.fromJson(res['data']) as NDIStatus));
        .pipe(map((res: any) => NDIStatus.fromJson(res)))
    );
    // return this.httpClient
    //   .get(this.createAPIURL(ParticipantApiService.CONTRACT_PARTICIPANTS_NDI_CHECKING), {
    //     headers: this.loadHeader(accessToken),
    //   })
    //   .pipe(map((res: any) => NDIStatus.fromJson(res['data']) as NDIStatus));
  }

  postTemporarySubmission(data: any, accessToken: string) {
    return this.apiService.post(ParticipantApiService.CONTRACT_ACTION_TEMPORARY_SUBMISSION, data, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_ACTION_TEMPORARY_SUBMISSION), data, {
    //   headers: this.loadHeader(accessToken),
    // });
  }

  sendFeedbackToAdmin(feedbackData: any, accessToken: string) {
    return this.apiService.post(ParticipantApiService.CONTRACT_FEEDBACK, feedbackData, {
      requestOptions: {
        headers: this.loadHeader(accessToken),
      },
    });
    // return this.httpClient.post(this.createAPIURL(ParticipantApiService.CONTRACT_FEEDBACK), feedbackData, {
    //   headers: this.loadHeader(accessToken),
    // });
  }
}
